// DO NOT EDIT THIS FILE MANUALLY. THIS IS AUTOMATICALLY UPDATED DURING RELEASE.
// See the .releaserc file in the root of the repo for more details.
export const VERSION = '9.21.0';
